import {useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import useMount from '@s-ui/react-hooks/lib/useMount'
import MoleculeModal from '@s-ui/react-molecule-modal'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import {useLocation} from '@s-ui/react-router'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {useMessagingContext} from '../../useMessagingContext/index.js'

export const BuyerIdentityTransactionModal = () => {
  const {state: routerState} = useLocation()
  const {domain, i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const {page} = useAnalyticsTrack()

  const config = domain.get('config')
  const pageName = config.get('page').TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_SUCCESS_PAGE_NAME

  useMount(async () => {
    const getTrackingData = async () => {
      return domain.get('get_page_tracking_data_use_case').execute({
        page: pageName
      })
    }

    const pageTrackingData = await getTrackingData()

    page(pageTrackingData)
  })

  const {address, city, email, lastName, name, phone, zipCode} = routerState || {}

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionBuyerIdentityModal-modalContainer">
        <MoleculeNotification
          alignItems={moleculeNotificationAlignItems.CENTER}
          autoClose={null}
          icon={<IconCircleCheck size="medium" />}
          position="relative"
          roundedCorners={moleculeNotificationBorderSizes.medium}
          show
          showCloseButton={false}
          showLeftIconMobile
          type={moleculeNotificationTypes.success}
          variation={moleculeNotificationVariations.positive}
        >
          {i18n.t(`VEHICLE_TRANSACTION.BUYER_IDENTITY.MODAL.NOTIFICATION_TEXT`)}
        </MoleculeNotification>
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionBuyerIdentityModal-modalChildren">
                  <div className="mt-TransactionBuyerIdentityModal-description">
                    {i18n.t('VEHICLE_TRANSACTION.BUYER_IDENTITY.MODAL.MAIN_TEXT')}
                  </div>
                  <div className="mt-TransactionBuyerIdentityModal-contentWrapper">
                    {name && lastName ? (
                      <div className="mt-TransactionBuyerIdentityModal-contentItem">
                        <strong>{`${name} ${lastName}`}</strong>
                      </div>
                    ) : (
                      <></>
                    )}
                    {email ? <div className="mt-TransactionBuyerIdentityModal-contentItem">{email}</div> : <></>}
                    {phone ? <div className="mt-TransactionBuyerIdentityModal-contentItem">{phone}</div> : <></>}
                    {address && city ? (
                      <div className="mt-TransactionBuyerIdentityModal-contentItem">{`${address}, ${city}`}</div>
                    ) : (
                      <></>
                    )}
                    {zipCode ? <div className="mt-TransactionBuyerIdentityModal-contentItem">{zipCode} </div> : <></>}
                    <div className="mt-TransactionBuyerIdentityModal-contentItem mt-TransactionBuyerIdentityModal-contentItem--dimmed">
                      <IconCircleCheck size={ATOM_ICON_SIZES.medium} />
                      {i18n.t('VEHICLE_TRANSACTION.BUYER_IDENTITY.MODAL.ID_ATTACHED')}
                    </div>
                  </div>
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.BUYER_IDENTITY.MODAL.TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
